import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-frontpage',
  templateUrl: './frontpage.component.html',
  styleUrls: ['./frontpage.component.css']
})
export class FrontpageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    const delay: number = Math.random() * 4;

    fetch('https://reqres.in/api/users?delay=' + delay)
      .then(response => response.json())
      .then(json => {
        //console.log(json);
        console.log("Dummy data fetched");
      });

  }

}
